<div class="form-container space-y-6" v-if="as === 'div'"><slot></slot></div><form class="space-y-6" v-else><slot></slot></form>